import { createNode } from '@/helpers/dom';
import prestashop from 'prestashop';

const load = async () => {
    // Mise à jour du contenu dynamique en ajax - la homepage, les pages catégories, les pages produit, les pages CMS et le blog sont misent en cache par Varnish
    // Voir le controller `modules/fractovarnish/controllers/front/datas.php` pour les datas retournées

    const need_dynamic_data = prestashop?.need_dynamic_data ?? false;
    if (need_dynamic_data != true) {
        return;
    }

    const data = new FormData();
    data.append('ajax', '1');

    // recupération informations produits si on est sur une page produit
    const element = document.querySelector('#product .js-product-actions');
    if (element) {
        const idProduct = <HTMLInputElement>(
            element.querySelector('input[name=id_product]')
        );
        if (idProduct) {
            data.append('id_product', idProduct.value);

            const idProductAttribute = <HTMLInputElement>(
                element.querySelector('input[name=idProductAttribute]')
            );
            if (idProductAttribute) {
                data.append('id_product_attribute', idProductAttribute.value);
            }

            const idCustomization = <HTMLInputElement>(
                element.querySelector('input[name=idCustomization]')
            );
            if (idCustomization) {
                data.append('id_customization', idCustomization.value);
            }
        }
    }

    const url = prestashop.urls.base_url;
    const response = await fetch(url + 'module/fractovarnish/datas', {
        method: 'POST',
        body: data,
        headers: {
            Accept: 'application/json',
        },
    });

    const json = await response.json();

    prestashop.emit('dynamic-data', json);
};

prestashop.on('dynamic-data', (data) => {
    // Replace templates with dynamic content
    Object.entries(data?.templates || {})
        // .filter(([template, html]) => html)
        .forEach(([template, html]) => {
            if (html) {
                const node = createNode(html as string);
                document
                    .querySelectorAll(`.js-dynamic-data-template-${template}`)
                    .forEach((elt) => {
                        const element = elt as HTMLElement;
                        const newNode =
                            node.querySelector(
                                `.js-dynamic-data-template-${template}`,
                            ) || node;
                        element.replaceWith(newNode);
                    });
            }
        });
});

export { load as DynamicDatas };
